export default __webpack_public_path__ + "static/media/AFin-Logo.85c73cc5.png";